import { configWithUserToken } from "./config";
import { getUserToken } from "../utils/Util";
import { ensureFreshToken } from "./tokenRefresh";
import {
  IMailListParams, IMailListResponse, IMailCounts, IMailDetail, IMailThread,
  IConvertToTicketRequest, IConvertToTicketResponse, IFilterRule,
  IAddFilterRuleRequest, IUpdateFilterRuleRequest, FilterListType,
} from "../models/ISupportMail";

const BASE_URL = process.env.REACT_APP_API_URL ?? "https://service.mutfacikservices.com/api/";

export const getMailMessages = (params: IMailListParams = {}) => {
  const p = new URLSearchParams();
  if (params.status && params.status !== "All") p.append("status", params.status);
  if (params.search) p.append("search", params.search);
  if (params.unreadOnly !== undefined) p.append("unreadOnly", String(params.unreadOnly));
  if (params.hasAttachment !== undefined) p.append("hasAttachment", String(params.hasAttachment));
  if (params.dateFrom) p.append("dateFrom", params.dateFrom);
  if (params.dateTo) p.append("dateTo", params.dateTo);
  p.append("pageIndex", String(params.pageIndex ?? 0));
  p.append("pageSize", String(params.pageSize ?? 20));
  return configWithUserToken.get<IMailListResponse>(`SupportMail/GetMessages?${p.toString()}`);
};

export const getMailCounts = () =>
  configWithUserToken.get<IMailCounts>("SupportMail/GetCounts");

export const getMailMessage = (id: string) =>
  configWithUserToken.get<IMailDetail>(`SupportMail/GetMessage/${id}`);

export const getMailThread = (threadId: string) =>
  configWithUserToken.get<IMailThread>(`SupportMail/GetThread/${threadId}`);

export const setMailReadState = (messageIds: string[], isRead: boolean) =>
  configWithUserToken.put<{ updatedCount: number }>("SupportMail/SetReadState", { messageIds, isRead });

export const convertMailToTicket = (payload: IConvertToTicketRequest) =>
  configWithUserToken.post<IConvertToTicketResponse>("SupportMail/ConvertToTicket", payload);

export const getMailFilterRules = (listType?: FilterListType) => {
  const qs = listType ? `?listType=${listType}` : "";
  return configWithUserToken.get<IFilterRule[]>(`SupportMail/GetFilterRules${qs}`);
};

export const addMailFilterRule = (payload: IAddFilterRuleRequest) =>
  configWithUserToken.post<IFilterRule>("SupportMail/AddFilterRule", payload);

export const updateMailFilterRule = (payload: IUpdateFilterRuleRequest) =>
  configWithUserToken.put<IFilterRule>("SupportMail/UpdateFilterRule", payload);

export const deleteMailFilterRule = (id: string) =>
  configWithUserToken.delete(`SupportMail/DeleteFilterRule/${id}`);

/**
 * Ek/gömülü görsel indirme ucu token istiyor; <a href>/<img src> ile doğrudan
 * açılamıyor (tarayıcı Authorization header'ı eklemez). Bu yüzden fetch ile
 * blob olarak çekilip URL.createObjectURL() ile gösterilir/indirilir.
 */
export const downloadMailAttachmentBlob = async (messageId: string, attachmentId: string): Promise<Blob> => {
  await ensureFreshToken();
  const token = getUserToken();
  const res = await fetch(`${BASE_URL}SupportMail/DownloadAttachment/${messageId}/${attachmentId}`, {
    headers: token ? { Authorization: `Bearer ${token.token}` } : {},
  });
  if (!res.ok) throw new Error(`Ek indirilemedi (HTTP ${res.status})`);
  return res.blob();
};
